require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./policies-compliance-privacy.json") })
        }
      }, "path---policies-compliance-privacy");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---policies-compliance-privacy!./.cache/json/policies-compliance-privacy.json
// module id = 891
// module chunks = 231608221292675